import { Spinner } from "@shopify/polaris";

export function FullPageLoader({ message }: { message?: string }) {
  return (
    <div className="full-page page-loader">
      <Spinner accessibilityLabel={message} size="large" />
      {message && <span>{message}</span>}
    </div>
  );
}
